export const RESOLVED_OPACITY = 0.6;
